import { render } from "./InputGeneric.vue?vue&type=template&id=16041e7e"
import script from "./InputGeneric.vue?vue&type=script&lang=ts"
export * from "./InputGeneric.vue?vue&type=script&lang=ts"
script.render = render

export default script